/**
 * @file_purpose  page for showing Fixed cost calculator dynamic form 
 * @author Sucheta Singha
 * @Date_Created 20-08-2024
 * @Date_Modified 20-08-2024
 */
import React, { useState, useEffect } from 'react'
import { useHistory, useParams, Link } from 'react-router-dom'
import {
    CLabel,
    CSelect,
    CFormGroup,
    CButton,
    CSpinner
} from '@coreui/react'
import { ToastContainer, toast } from 'react-toastify';
import GeneralService from "src/apis/GeneralService";
import Constants from "src/Utility/Constants";
import RouteURL from "src/apis/ApiURL";
import { Range, getTrackBackground } from 'react-range';
import masterData from 'src/Utility/MasterData';

const STEP = 1;
const MIN = 5000;
const MAX = 50000000;

export default function FixedCostCalculator() {

    const history = useHistory();
    const [loadingData, setLoadingData] = useState(true);
    const [formFields, setFormFields] = useState([]);
    const [fieldErrors, setFieldErrors] = useState([]);
    let fieldErrorArray = [];
    let { service_id } = useParams();
    let { category_id } = useParams();
    const [loader, setLoader] = useState(0);
    const [isButtonDisable, setIsButtonDisable] = useState(true);
    // const [budgetValues, setBudgetValues] = useState([20000000]);
    const [budgetValues, setBudgetValues] = useState();
    const prevValue = JSON.parse(localStorage.getItem('fixed-cost-calculator'))
    const _budgetValues = localStorage.getItem('budgetValues')
    // const _budgetValues = JSON.parse(localStorage.getItem('budgetValues'))

    useEffect(() => {
        // console.log(prevValue)

        if (prevValue && formFields?.length > 0) {
            let newFormValues = [...formFields];

            prevValue.map(obj => {
                newFormValues.map((object) => {
                    if (object.field_type === "drop_down") {
                        if (object.field_id === obj.field_id) {
                            object["value"] = obj.values;
                        }
                    } else if (object.field_type === "checkbox") {
                        if (object.field_id === obj.field_id) {
                            object["value"] = obj.values;
                        }

                    } else if (object.field_type === "radio") {
                        if (object.field_id === obj.field_id) {
                            object["value"] = obj.values;
                        }
                    }

                })
            })
            // console.log(newFormValues);
            setBudgetValues([_budgetValues])
            setFormFields(newFormValues);
            setIsButtonDisable(false)
        }
        // console.log(formFields);

    }, [(formFields?.length > 0)])

    useEffect(() => {

        /**
      * @author Sucheta Singha
      * @Date_Created 21-08-2024
      * @Date_Modified 21-08-2024
      * @function async
      * @functionName loadCostCategories
      * @functionPurpose this function gets the list of categories.
      *
      * @functionParam {}
      * 
      * @functionSuccess Success status and message.
      *
      * @functionError {Boolean} error is there.
      * @functionError {String} message  Description message.
      */

        async function loadCostCategories() {
            let params = JSON.stringify({
                field_id: null,
                field_category_id: category_id,
            })
            GeneralService.apiPostCallRequestWithoutToken(RouteURL.getCategoryFields, params)
                .then((res) => {
                    if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {
                        // setFormFields(res.data);
                        let response = res.data;
                        setLoadingData(false)
                        response.forEach((object) => {
                            object.field_values.forEach((obj) => {
                                obj.isActive = false;
                            })
                        });
                        // console.log(response);

                        setFormFields(response);
                    }
                    else {
                        toast.error(res.message, {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                    }
                }).catch(error => {
                    console.log(error)
                })

        }

        if (loadingData) {
            loadCostCategories()
        }

    }, [loadingData]);



    const handleChangeRadioCheckbox = (j, fieldType, i, e, item) => {
        let newFormValues = [...formFields]

        if (fieldType === "checkbox") {
            if (newFormValues[i]["value"] == null) {
                newFormValues[i]["value"] = [];

                if (e.target.checked) {
                    newFormValues[i]["value"].push(item);
                }

            } else {
                if (e.target.checked) {
                    newFormValues[i]["value"] = [...newFormValues[i]["value"]]
                    newFormValues[i]["value"].push(item);

                } else {
                    // newFormValues[i]["value"].splice(j, 1)
                    let positionOfItem = newFormValues[i]["value"].indexOf(item);
                    newFormValues[i]["value"].splice(positionOfItem, 1);
                }
            }
        }
        else {
            if (e.target.checked) {
                newFormValues[i]["value"] = item;
            }
        }

        setFormFields(newFormValues);
        if (checkedValidation()) {
            setIsButtonDisable(false)
        } else {
            setIsButtonDisable(true)
        }

    }

    const handleChangeSelectBox = (fieldId, fieldType, i, e, item) => {
        let newFormValues = [...formFields]
        newFormValues[i]["value"] = e.target.value;
        setFormFields(newFormValues);
        if (checkedValidation()) {
            setIsButtonDisable(false)
        } else {
            setIsButtonDisable(true)
        }
    }

    const checkedValidation = () => {
        let formIsValid = true;
        for (let i = 0; i < formFields.length; i++) {
            if (!formFields[i]?.value && (formFields[i]?.is_required == 1)) {
                formIsValid = false;
            }
        }
        return formIsValid;
    }

    /* Validation Checking */
    const FormSubmitValidateForm = (e) => {
        e.preventDefault();
        if (formHandleValidation()) {
            formSubmitSubmitClick();
        }
    }

    const formHandleValidation = () => {
        let fieldErrors;
        let formIsValid = true;

        for (let i = 0; i < formFields.length; i++) {
            if (!formFields[i]?.value && (formFields[i]?.is_required == 1)) {
                formIsValid = false;
                fieldErrors = ` ${formFields[i]?.field_name} can not be empty`;
            } else {
                fieldErrors = null
            }

            if (fieldErrors) {
                fieldErrorArray.push({ fieldErrors: fieldErrors })
                setFieldErrors(fieldErrorArray)
            } else {
                fieldErrorArray.push({ fieldErrors: null })
                setFieldErrors(fieldErrorArray)
            }
        }

        return formIsValid;
    }




    const formSubmitSubmitClick = async (e) => {
        setIsButtonDisable(true);
        setLoader(1);
        let fieldList = [];
        let fieldDetails;

        formFields.map((item, index) => {

            fieldDetails = {
                field_id: item.field_id,
                values: item.value
            }
            fieldList.push(fieldDetails);
        })

        history.push({
            pathname: "/contact-form/fixed-cost-calculator",
            state: { fields: fieldList, budget: budgetValues }
        });
        localStorage.setItem('fixed-cost-calculator', JSON.stringify(fieldList))
        localStorage.setItem('budgetValues', budgetValues)
    }

    const GoBackClick = (e) => {
        e.preventDefault();
        history.goBack()
    }

    // const sendHeight = () => {
    //     // Send the height of the iframe content to the parent page
    //     window.parent.postMessage(document.body.scrollHeight, '*');
    // }

    // // Send height initially and on content changes
    // window.addEventListener('load', sendHeight);
    // window.addEventListener('resize', sendHeight);

    // const observer = new MutationObserver(sendHeight);
    // observer.observe(document.body, { childList: true, subtree: true });


    const sendHeight = () => {
        // Send the height of the iframe content to the parent page
        window.parent.postMessage(document.body.scrollHeight, '*');
    };

    // Debounce function to limit the number of times sendHeight is called
    const debounce = (func, delay) => {
        let timer;
        return function () {
            clearTimeout(timer);
            timer = setTimeout(func, delay);
        };
    };

    // Create debounced version of sendHeight
    const debouncedSendHeight = debounce(sendHeight, 100);

    // Send height initially and on content changes
    window.addEventListener('load', debouncedSendHeight);
    window.addEventListener('resize', debouncedSendHeight);

    // Observe changes in the DOM with a slight delay to ensure rendering is complete
    const observer = new MutationObserver(debouncedSendHeight);
    observer.observe(document.body, { childList: true, subtree: true });

    return (
        <body style={{ backgroundColor: "#fff" }}>

            <div className="appoinment_hed">
                <h4>
                    Lets Calculate The Ballpark Cost Of Your Project
                </h4>

                <div className=''>
                    <div className='row'>

                        <div className='col-sm-6 col-xl-6 col-lg-6 col-md-6 col-sm-12'>
                            <div className='ball_park'>
                                <div className='ball_park_num'>
                                    <p>1</p>
                                </div>
                                <div className='ball_park_txt'>
                                    <p>Fill in the required inputs below with relevant info.</p>
                                </div>
                            </div>
                        </div>

                        <div className='col-sm-6 col-xl-6 col-lg-6 col-md-6 col-sm-12'>
                            <div className='ball_park'>
                                <div className='ball_park_num'>
                                    <p>2</p>
                                </div>
                                <div className='ball_park_txt'>
                                    <p>Press "Calculate" button in order to get the ballpark price.</p>
                                </div>
                            </div>
                        </div>

                        {/* <div className='col-sm-4'>
                            <div className='ball_park'>
                                <div className='ball_park_num'>
                                    <p>3</p>
                                </div>
                                <div className='ball_park_txt'>
                                    <p>Contact us to get accurate estimations.</p>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
                <div className=''>
                    <div className="main_calculator">
                        {loader ?
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute', width: '100%', marginTop: "10%" }}> <CSpinner
                                style={{ width: '4rem', height: '4rem', }}
                                color="danger"
                                variant="grow"
                                className="loader_z_index"
                            />
                            </div>
                            : ""}

                        <div className='row'>
                            {formFields?.map((element, index) => (
                                <>

                                    {element.field_type === "checkbox" ?
                                        <>
                                            <div className="col-md-12">
                                                <div className='platform_sec'>
                                                    <CLabel htmlFor="text-input"> {element.field_name} {element.is_required ? <span style={{ color: "#4A4B4C" }}><b> *</b></span> : ""}</CLabel>
                                                    <br></br>
                                                    <div className='row'>
                                                        {element.field_values &&
                                                            element.field_values.map((item, j) => (

                                                                <div className={"col-md-" + parseInt(12 / element?.value_partitions) + " pr-0"}>
                                                                    {/* <input type='checkbox' name={"checkbox" + element.field_category_id} id={"checkbox" + element.field_category_id}
                                                                        onChange={e => handleChangeRadioCheckbox(j, element.field_type, index, e, item.value_id)}
                                                                    />&nbsp;
                                                                    <CLabel>{item.value_name} </CLabel> */}

                                                                    <div className='require_box'>
                                                                        <label class={formFields[index]?.value?.find((element) => element == item.value_id) ? "con1 label_drk" : "con1"}><span>{item.value_name}</span>
                                                                            <input type='checkbox' name={"checkbox" + element.field_category_id} id={"checkbox" + element.field_category_id} checked={formFields[index]?.value?.find((element) => element == item.value_id)}
                                                                                onChange={e => handleChangeRadioCheckbox(j, element.field_type, index, e, item.value_id)}
                                                                            />
                                                                            <span class="checkmark"></span>
                                                                        </label>
                                                                    </div>
                                                                </div>

                                                            ))}
                                                    </div>

                                                    {element.is_required == 1 ?
                                                        <span style={{ color: "red" }}> {fieldErrors && fieldErrors.length > 0 ? fieldErrors[index].fieldErrors : ""}</span>
                                                        : ""}
                                                </div>
                                            </div>
                                        </>

                                        : (element.field_type === "radio" ?
                                            <>
                                                <div className='additional_sec'>
                                                    <div className="col-md-12">
                                                        <CLabel htmlFor="text-input"> {element.field_name} {element.is_required ? <span style={{ color: "#4A4B4C" }}><b> *</b></span> : ""}</CLabel>
                                                        <br></br>
                                                        <div className='row'>
                                                            {element.field_values &&
                                                                element.field_values.map((item, j) => (
                                                                    <div className={"col-md-" + parseInt(12 / element?.value_partitions) + " pr-0"}>



                                                                        <div className='require_box'>
                                                                            <label class={item.value_id == element.value ? "con1 label_drk" : "con1"}><span>{item.value_name}</span>
                                                                                <input name={"radio" + element.field_category_id} id={"radio" + element.field_category_id} type='radio'
                                                                                    onChange={e => handleChangeRadioCheckbox(j, element.field_type, index, e, item.value_id)}
                                                                                />
                                                                                <span class="checkmark"></span>
                                                                            </label>
                                                                        </div>



                                                                        {/* <input name={"radio" + element.field_category_id} id={"radio" + element.field_category_id} type='radio'
                                                                            onChange={e => handleChangeRadioCheckbox(j, element.field_type, index, e, item.value_id)}
                                                                        />&nbsp;
                                                                        <CLabel> {item.value_name}</CLabel>
                                                                        <br></br> */}
                                                                    </div>
                                                                ))}
                                                        </div>

                                                        {element.is_required == 1 ?
                                                            <span style={{ color: "red" }}> {fieldErrors && fieldErrors.length > 0 ? fieldErrors[index].fieldErrors : ""}</span>
                                                            : ""}
                                                    </div>
                                                </div>
                                            </>
                                            :
                                            (
                                                <>

                                                    <div className="col-md-6 pr-0">
                                                        <div className='fixed_cost_sec'>
                                                            <CLabel htmlFor="text-input" > {element.field_name} {element.is_required ? <span style={{ color: "#4A4B4C" }}><b> *</b></span> : ""}</CLabel>
                                                            <br></br>
                                                            <CSelect
                                                                custom style={{ color: element.value ? "#000" : "#aba4a4" }}
                                                                name={"select" + element.field_category_id}
                                                                id={"select" + element.field_category_id}
                                                                value={element.value}
                                                                onChange={e => handleChangeSelectBox(element.field_id, element.field_type, index, e, "")}

                                                            >
                                                                {/* <option value=""> Select&nbsp;{element.field_name}</option> */}
                                                                <option value=""> {element.place_holder ? element.place_holder : `${'Select' + ' ' + element.field_name}`}</option>

                                                                {element.field_values &&
                                                                    element.field_values.map((item, index) => (
                                                                        <option key={item.value_id} value={item.value_id} >
                                                                            {item.value_name}
                                                                        </option>
                                                                    ))}
                                                            </CSelect>
                                                            {element.is_required == 1 ?
                                                                <span style={{ color: "red" }}> {fieldErrors && fieldErrors.length > 0 ? fieldErrors[index].fieldErrors : ""}</span>
                                                                : ""}
                                                        </div>
                                                    </div>

                                                </>)
                                        )}
                                </>
                            ))}
                            <div className="col-md-6 pr-0">
                                <div className=''>
                                    <CLabel htmlFor="text-input" style={{ fontWeight: 700 }}> What is your estimated budget for the project?</CLabel>
                                    <br></br>

                                    <CSelect
                                        custom style={{ color: budgetValues ? "#000" : "#aba4a4" }}
                                        id='budgetValues'
                                        name='budgetValues'
                                        value={budgetValues}
                                        onChange={(e) => setBudgetValues(e.target.value)}

                                    >
                                        <option value=""> Select</option>
                                        {masterData.budgetValues.map((item) => {
                                            return (<option value={item.value}> {item.value}</option>)
                                        })}
                                    </CSelect>
                                </div>
                            </div>
                        </div>


                        {/* <div className='budget_sec'> */}
                        {/* <div className="col-md-6 pr-0">
                            <div className=''>
                                <CLabel htmlFor="text-input" style={{ fontWeight: 700 }}> What is your estimated budget for the project?</CLabel>
                                <br></br>

                                <CSelect
                                    custom style={{ color: budgetValues ? "#000" : "#aba4a4" }}
                                    id='budgetValues'
                                    name='budgetValues'
                                    value={budgetValues}
                                    onChange={(e) => setBudgetValues(e.target.value)}

                                >
                                    <option value=""> Select</option>
                                    {masterData.budgetValues.map((item) => {
                                        return (<option value={item.id}> {item.value}</option>)
                                    })}
                                </CSelect>
                            </div>
                        </div> */}
                        {/* <Range
                                values={budgetValues}
                                step={STEP}
                                min={MIN}
                                max={MAX}
                                // rtl={rtl}
                                onChange={(values) => setBudgetValues(values)}
                                renderTrack={({ props, children }) => (
                                    <div className='budget_bar'
                                        onMouseDown={props.onMouseDown}
                                        onTouchStart={props.onTouchStart}
                                        style={{
                                            ...props.style,
                                            height: '36px',
                                            display: 'flex',
                                            width: '100%',
                                        }}
                                    >
                                        <div
                                            ref={props.ref}
                                            className='budget_bar1'
                                            style={{
                                                height: '9px',
                                                width: '100%',
                                                borderRadius: '4px',
                                                backgroundColor: "#000",
                                                background: getTrackBackground({
                                                    values: budgetValues,
                                                    colors: ['#E74C3C', '#DFDFDF'],
                                                    min: MIN,
                                                    max: MAX,
                                                }),
                                                alignSelf: 'center',
                                            }}
                                        >
                                            {children}
                                        </div>
                                    </div>
                                )}
                                renderThumb={({ props, isDragged }) => (
                                    <div
                                        {...props}
                                        key={props.key}
                                        style={{
                                            ...props.style,
                                            height: '19px',
                                            width: '19px',
                                            borderRadius: '50px',
                                            backgroundColor: '#fff',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            border: '1px solid #e94c3c'
                                        }}
                                    >
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: "-28px",
                                                color: "#000",
                                                fontWeight: "bold",
                                                fontSize: "16px",
                                                fontFamily: "Arial,Helvetica Neue,Helvetica,sans-serif",
                                                padding: "4px",
                                                borderRadius: "4px",
                                            }}
                                        >
                                            ${budgetValues}
                                        </div>
                                        <div
                                            style={{
                                                height: '16px',
                                                width: '0px',
                                                backgroundColor: isDragged ? '#548BF4' : '#CCC',
                                            }}
                                        />
                                    </div>
                                )}
                            />
                            <output style={{ marginTop: '10px', marginBottom: "20px" }} id="output">
                                <span className='minval_sec'>${MIN}</span>
                                <span className='btmval_sec'>${MAX}</span>
                            </output> */}
                        {/* </div> */}

                    </div>
                    <div className="booking_btns_sec">
                        <div className="atten_sec1 col-12 text-center">
                            <CButton className="cancel" onClick={GoBackClick}
                                style={{ marginRight: 10 }}
                            > <i class="fa-solid fa-chevron-left"></i> Back</CButton>

                            <CButton className="save"
                                onClick={FormSubmitValidateForm}
                                disabled={isButtonDisable ? true : false}
                                style={{ background: isButtonDisable ? '#DFDFDF' : '#E84C3D' }}
                            >
                                Calculate <i class="fa-solid fa-angle-right right_ang"></i>
                            </CButton>
                        </div>
                    </div>
                </div>
            </div>

        </body>
    )
}




